const jobPositionStatuses = [
  {
    name: "Open",
    value: "OPEN",
  },
  {
    name: "Closed",
    value: "CLOSED",
  },
];

export default jobPositionStatuses;
